"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _RightPaneWidgetFrame = _interopRequireDefault(require("../01_atoms/RightPaneWidgetFrame"));

var _BillingDetailsWidget = _interopRequireDefault(require("./BillingDetailsWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var BillingDetailsRightPane = function BillingDetailsRightPane(_ref) {
  var sdk = _ref.sdk,
      _ref$onBillingDetails = _ref.onBillingDetailsValidated,
      onBillingDetailsValidated = _ref$onBillingDetails === void 0 ? function () {} : _ref$onBillingDetails,
      _ref$focusedLeftItemI = _ref.focusedLeftItemId,
      focusedLeftItemId = _ref$focusedLeftItemI === void 0 ? null : _ref$focusedLeftItemI;
  return /*#__PURE__*/_react["default"].createElement(_RightPaneWidgetFrame["default"], {
    focusedLeftItemId: focusedLeftItemId
  }, /*#__PURE__*/_react["default"].createElement(_BillingDetailsWidget["default"], {
    sdk: sdk,
    userPassengerId: sdk.passengers.getUserPassengerId(),
    savedPassengers: sdk.passengers.getAllSavedPassengers(),
    billingPassengerId: sdk.billingDetails.getBillingPassengerId(),
    setBillingInfo: /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                sdk.billingDetails.setBillingDetails(data);
                onBillingDetailsValidated(null);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(),
    translatorForNamespace: sdk.i18n.translatorForNamespace
  }));
};

var _default = BillingDetailsRightPane;
exports["default"] = _default;